import { useState } from 'react';

const useLoading = (initialLoading: boolean = true) => {
  const [loading, setLoading] = useState<boolean>(initialLoading);

  return {
    loading,
    changeLoading: (loadingState: boolean) => setLoading(loadingState),
  };
};

export default useLoading;
